module.exports = __webpack_public_path__ + "static/media/memberGroupCreatedIcon.5811bbca.png";